export default [
  {
    path: 'inventory-summary',
    name: 'report-inventory-summary',
    component: () =>
      import('@/view/pages/reports/inventory-summary/Report.vue'),
    meta: {
      title: 'Báo cáo tồn kho - CLICKBUY',
    },
  },
];
